import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
// Add Vuex To VUE
Vue.use(Vuex)
const BACK = 'BACK'
const FORM = 'FORM'
const ITEM = 'ITEM'
const ITEMUPDATE = 'ITEMUPDATE'
const FORMUPDATE = 'FORMUPDATE'
const RESET = 'RESET'
const RESETITEM = 'RESETITEM'
const HISTORIAL = 'HISTORIAL'
const TRACE = 'TRACE'
const TIPO = 'TIPO'
const LOADSUS = 'LOADSUS'
const LOADPER = 'LOADPER'
const LOADFONDO = 'LOADFONDO'
const LOADFONDOSUS = 'LOADFONDOSUS'
const LOADTITULARM = 'LOADTITULARM'
const LOADTITULARP = 'LOADTITULARP'
const RESETCOMPONENT = "RESETCOMPONENT"
const form = {}
const item = {}
const history = {
  form0:{id:"0",nombre:"Solicitud de Suscripción Adicional", enviado:false, stepper:false, show:false},
  form1:{id:"1",nombre:"Datos Personales del Partícipe", enviado:false, stepper:false, show:false},
  form21:{id:"21",nombre:"Información Mancomunos", enviado:false, stepper:false, show:false},
  form22:{id:"22",nombre:"Representante Legal", enviado:false, stepper:false, show:false},
  form23:{id:"23",nombre:"Información Representante legal", enviado:false, stepper:false, show:false},
  form2:{id:"2",nombre:"Información del Primer Mancomuno", enviado:false, stepper:false, show:false},
  form3:{id:"3",nombre:"Información del Segundo Mancomuno", enviado:false, stepper:false, show:false},
  form4:{id:"4",nombre:"Tipo de Inversionista", enviado:false, stepper:false, show:false},
  form5:{id:"5",nombre:"Inversionista Institucional", enviado:false, stepper:false, show:false},
  form6:{id:"6",nombre:"Información de Partícipe", enviado:false, stepper:false, show:false},
  form7:{id:"7",nombre:"Origen de Fondos", enviado:false, stepper:false, show:false},
  form8:{id:"8",nombre:"Información del Aporte", enviado:false, stepper:false, show:false},
  form9:{id:"9",nombre:"Observaciones Adicionales", enviado:false, stepper:false, show:false},
  form10:{id:"10",nombre:"Confirmación", enviado:false, stepper:false, show:false},
}
const historyParticipe = {
  item000:{id:"000",nombre:"Información", enviado:false, stepper:false, show:false},
  item1:{id:"1",nombre:"Datos Personales del Partícipe", enviado:false, stepper:false, show:false},
  item2:{id:"2",nombre:"Representante Legal", enviado:false, stepper:false, show:false},
  item3:{id:"3",nombre:"Residencia Fiscal", enviado:false, stepper:false, show:false},
  item4:{id:"4",nombre:"Información de Residencia Fiscal", enviado:false, stepper:false, show:false},
  item5:{id:"5",nombre:"Datos de la Actividad Laboral", enviado:false, stepper:false, show:false},
  item6:{id:"6",nombre:"Datos de la actividad", enviado:false, stepper:false, show:false},
  item7:{id:"7",nombre:"Cargos Públicos", enviado:false, stepper:false, show:false},
  item8:{id:"8",nombre:"Cargos Públicos - Información", enviado:false, stepper:false, show:false},
  item9:{id:"9",nombre:"Tipo de Partícipe", enviado:false, stepper:false, show:false},
  item10:{id:"10",nombre:"Información de Suscripción Inicial", enviado:false, stepper:false, show:false},
  item11:{id:"11",nombre:"Porcentaje de Cuotas", enviado:false, stepper:false, show:false},
  item12:{id:"12",nombre:"Inversionista Institucional", enviado:false, stepper:false, show:false},
  item13:{id:"13",nombre:"Cuestionario de Perfil de Riesgo del Inversionista", enviado:false, stepper:false, show:false},
  item14:{id:"14",nombre:"Información de Partícipe", enviado:false, stepper:false, show:false},
  item15:{id:"15",nombre:"Información del Aporte", enviado:false, stepper:false, show:false},
  item16:{id:"16",nombre:"Observaciones Adicionales", enviado:false, stepper:false, show:false},
  item17:{id:"17",nombre:"Declaración Jurada de Origen de Fondos", enviado:false, stepper:false, show:false},
  item18:{id:"18",nombre:"Declaración Jurada de Origen de Fondos (Datos)", enviado:false, stepper:false, show:false},
  item19:{id:"19",nombre:"Declaración Jurada de Origen de Fondos", enviado:false, stepper:false, show:false},
  item20:{id:"20",nombre:"Información del Estado de Cuenta", enviado:false, stepper:false, show:false},
  item21:{id:"21",nombre:"Correo Electrónico para Envío de Estado de Cuenta", enviado:false, stepper:false, show:false},
  item30:{id:"30",nombre:"", enviado:false, stepper:false, show:false},  
}
const historyMancomuno = {
  item000:{id:"000",nombre:"Información", enviado:false, stepper:false, show:false},
  item0:{id:"0",nombre:"Información de Mancomunos", enviado:false, stepper:false, show:false},
  item01:{id:"01",nombre:"Información del Mancomuno", enviado:false, stepper:false, show:false},
  item2:{id:"2",nombre:"Representante Legal", enviado:false, stepper:false, show:false},
  item3:{id:"3",nombre:"Residencia Fiscal", enviado:false, stepper:false, show:false},
  item4:{id:"4",nombre:"Información de Residencia Fiscal", enviado:false, stepper:false, show:false},
  item5:{id:"5",nombre:"Datos de la Actividad Laboral", enviado:false, stepper:false, show:false},
  item6:{id:"6",nombre:"Datos de la actividad", enviado:false, stepper:false, show:false},
  item7:{id:"7",nombre:"Cargos Públicos", enviado:false, stepper:false, show:false},
  item8:{id:"8",nombre:"Cargos Públicos - Información", enviado:false, stepper:false, show:false},
  item10:{id:"10",nombre:"Tipo de Inversionista del Partícipe Titular", enviado:false, stepper:false, show:false},
  item12:{id:"12",nombre:"Inversionista Institucional", enviado:false, stepper:false, show:false},
  item13:{id:"13",nombre:"Cuestionario de Perfil de Riesgo del Inversionista", enviado:false, stepper:false, show:false},
  item16:{id:"16",nombre:"Observaciones Adicionales", enviado:false, stepper:false, show:false},
  item19:{id:"19",nombre:"Declaración Jurada de Origen de Fondos 3", enviado:false, stepper:false, show:false},
  item20:{id:"20",nombre:"Información del Estado de Cuenta", enviado:false, stepper:false, show:false},
  item21:{id:"21",nombre:"Correo Electrónico para Envío de Estado de Cuenta", enviado:false, stepper:false, show:false},
  item30:{id:"30",nombre:"", enviado:false, stepper:false, show:false},  
}

const url = 'farocapitalsafi.com'
//const url = '45.79.100.64'


const cloneItem = JSON.parse(JSON.stringify(item));
const cloneForm = JSON.parse(JSON.stringify(form));
const cloneResetItem = JSON.parse(JSON.stringify(item));
const cloneResetForm = JSON.parse(JSON.stringify(form));

const cloneHistory = JSON.parse(JSON.stringify(history));
const cloneHistoryParticipe = JSON.parse(JSON.stringify(historyParticipe));
const cloneHistoryMancomuno = JSON.parse(JSON.stringify(historyMancomuno));

// STATE
const state = {
    url: url,
    back: false,
    form: cloneForm,
    item: cloneItem,
    reset: {
      form: cloneResetForm,
      item: cloneResetItem,
    },
    active: null,
    history: cloneHistory,
    historyParticipe: cloneHistoryParticipe,
    historyMancomuno: cloneHistoryMancomuno,
    tipo: null,
    trace:[], 
    traceName: []
  }

// MUTATIONS
const mutations = {
  [BACK] (state, json) {
    state.back = json
  },
  [FORM] (state, json) {
    state.form["form"+json.id] = json.form
    state.trace.push(json.id)
    state.traceName.push(state.history["form"+json.id].nombre)
  },
  [ITEM] (state, json) {
    state.item["item"+json.id] = json.form
    state.trace.push(json.id)
  }, 
  [ITEMUPDATE] (state, json) {
    state.item["item"+json.id] = json.form
  },   
  [FORMUPDATE] (state, json) {
    state.item["form"+json.id] = json.form
  },    
  [RESET] (state, json) {
    state.form[json.id] = json.form
  },
  [RESETITEM] (state, json) {
    state.item[json.id] = json.form
  },    
  [HISTORIAL] (state, json) {
    state.history = json
  },
  [TRACE] (state) {
    state.trace.pop()
    state.traceName.pop()
  },
  [TIPO] (state, json ) {
    state.tipo = json.tipo
    state.active = json.active
  },
  [LOADPER] (state, json) {
    state.active = json.active
    state.item = JSON.parse(json.state)
    state.trace = JSON.parse(json.trace)
  },  
  [LOADSUS] (state, json) {
    state.active = json.active
    state.form = JSON.parse(json.state)
    state.trace = JSON.parse(json.trace)
  },   
  [LOADFONDO] (state, json) {
    if(state.item.item14.fondomutuoinvertir.length == 0){
      state.item.item14.fondomutuoinvertir = json
      //state.reset.item.item14.fondomutuoinvertir = json;
    }
  },
  [LOADFONDOSUS] (state, json) {
    if(state.form.form5.fondomutuoinvertir.length == 0){
      state.form.form5.fondomutuoinvertir = json;
      //state.reset.form.form5.fondomutuoinvertir = json;
    }
  },
  [LOADTITULARM] (state, json) {

    if(json.length > 0){
      var d = json[0]
      state.item.item0.nombres = (!state.item.item0.nombres) ? d.Nombre : null;
      state.item.item0.materno = (!state.item.item0.Apellidomaterno) ? d.Apellidomaterno : null;
      state.item.item0.paterno = (!state.item.item0.Apellidopaterno) ? d.Apellidopaterno : null;
      state.item.item0.nroIdentidad = (!state.item.item0.NroDocumento) ? d.NroDocumento : null;
      state.item.item0.docIdentidad = (!state.item.item0.TipoDocumento) ? d.TipoDocumento : null;
      state.item.item0.email = (!state.item.item0.Email) ? d.Email : null;
      state.item.item0.celular = (!state.item.item0.Celular) ? d.Celular : null;
    }
  },
  [LOADTITULARP] (state, json) {
    if(json.length > 0){
      var d = json[0]
      state.item.item1.nombres = (!state.item.item1.nombres) ? d.Nombre : null;
      state.item.item1.materno = (!state.item.item1.Apellidomaterno) ? d.Apellidomaterno : null;
      state.item.item1.paterno = (!state.item.item1.Apellidopaterno) ? d.Apellidopaterno : null;
      state.item.item1.nroIdentidad = (!state.item.item1.NroDocumento) ? d.NroDocumento : null;
      state.item.item1.docIdentidad = (!state.item.item1.TipoDocumento) ? d.TipoDocumento : null;
      state.item.item1.email = (!state.item.item1.Email) ? d.Email : null;
      state.item.item1.celular = (!state.item.item1.Celular) ? d.Celular : null;
      state.item.item9.titularidad = (!state.item.item9.titularidad) ? d.TipoCuenta : null;
    }
  },
  [RESETCOMPONENT](state, json){
    Object.keys(json).forEach(key => {
      json[key].show = false
  });    
  }
}

// ACTIONS
const actions = ({
    back ({ commit }, json) {
      commit('BACK', json);
    },  
    form ({ commit, dispatch }, json) {
        commit('FORM', json.form);
        return dispatch('saveFormulario', json)
    },
    item ({ commit, dispatch }, json) {
      commit('ITEM', json.form);
      return dispatch('saveFormulario', json)
    },
    itemUpdate ({ commit }, json) {
      commit('ITEMUPDATE', json.form);
    },
    formUpdate ({ commit }, json) {
      commit('FORMUPDATE', json.form);
    },      
    reset ({ commit, dispatch }, json) {
      commit('RESET', json);
      return dispatch('saveFormulario', json)
    },
    resetitem ({ commit, dispatch }, json) {
      commit('RESETITEM', json);
      return dispatch('saveFormulario', json)
    },       
    historial ({ commit }, json) {
      commit('HISTORIAL', json);
    },
    trace ({ commit }) {
      commit('TRACE');
    }, 
    tipo ({ commit }, json) {
      commit('TIPO', json);
    },
    saveFormulario({state}, json){
      var type = null;
      var form = null;
      switch (state.tipo) {
        case "P":
          type = "Participe";
          form = state.item;
          break;
        case "M":
          type = "Mancomuno";
          form = state.item;
          break;    
        case "S":
          type = "Suscripcion";
          form = state.form;
          break;              
      }
      var data = {
          id: json.ide,
          state: JSON.stringify(form),
          active: state.active.toString(),
          Trace: JSON.stringify(state.trace),
          Complete: json.complete,
          type: type,
          Action: "0"       
      }

      if(!(typeof(json.user)=== "undefined")){
        if(json.user != null){
          data.user = json.user
        }  
      }

      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: 'https://'+url+':5001/api/Formularios/SetFormularios',
          data: data
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
      })
    },
    loadFormulario({state, commit}, id){

      var type = null;
      switch (state.tipo) {
        case "P":
          type = "Participe";
          break;
        case "M":
          type = "Mancomuno";
          break;    
        case "S":
          type = "Suscripcion";
          break;              
      }
      var data = {
          id:id,
          action: type,
      }
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: 'https://'+url+':5001/api/Formularios/GetFormularios2',
          data: data
        })
        .then(function (response) {
        
            var con = "LOADPER";
            if(state.tipo == "S"){
              con = "LOADSUS";
            }
            var r = response.data;
            if(r.data.length > 0){
              var res = r.data[0]
              commit(con, res)
              resolve(res)
            }
            else{
              resolve(r.data)
            }
        })
        .catch(function (e) {
          reject(e)
        })
      })
    },
    saveImgFormulario(json){
      /*
      var type = null;
      switch (state.tipo) {
        case "P":
          type = "Participe";
          break;
        case "M":
          type = "Mancomuno";
          break;    
        case "S":
          type = "Suscripcion";
          break;              
      }
      console.log(type)
      */
      var config = {
        method: 'post',
        url: 'https://'+url+':5001/api/Util/Upload',
        headers: {
                'Content-Type': 'multipart/form-data'
        },
        data : json,
      };
      return new Promise((resolve, reject) => {
        axios(config)
        .then(function (response) {
          try{
            resolve(response)
          }catch(e){
            reject(e)
          }
        })
        .catch(function (e) {
          reject(e)
        })
      })
    },
    loadPais(){

      var config = {
        method: 'post',
        url: 'https://'+url+':5001/api/Util/Pais',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
      };
      return new Promise((resolve, reject) => {
        axios(config)
        .then(function (response) {
          try{
            resolve(response)
          }catch(e){
            reject(e)
          }
        })
        .catch(function (e) {
          reject(e)
        })
      })
    },
    loadFondos({commit}, tipo){
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: 'https://'+url+':5001/api/Util/FondosAux'
        })
        .then(function (response) {
          try{

            var con = "LOADFONDOSUS";
            if(tipo != 'S'){
              con = "LOADFONDO";
            } 
            var res = response.data;
            if(res.success){
              commit(con, res.data)
              resolve()
            }else{
              throw new Error('¡Ups!')
            }
          }catch(e){
            reject(e)
          }

        })
        .catch(function (e) {
          reject(e)
        })
      })
    },

    loadDataTitular({commit}, token){
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: 'https://'+url+':5001/api/Formularios/GetFormularioTitular',
          data: {token: token.token}
        })
        .then(function (response) {
          try{
            var res = response.data;
            if(res.success){
              if(response.data.data.length > 0){
                var row = response.data.data
                if(token.router == 'Mancomuno'){
                  commit('LOADTITULARM', row)
                }else{
                  commit('LOADTITULARP', row)
                }
                resolve(res)
              }else{
                throw new Error('No existen registros')
              }

            }else{
              throw new Error('¡Ups!')
            }
          }catch(e){
            reject(e)
          }

        })
        .catch(function (e) {
          reject(e)
        })
      })
    },
    hideAllComponent({state, commit}){
      commit("RESETCOMPONENT", state.history)
      commit("RESETCOMPONENT", state.historyMancomuno)
      commit("RESETCOMPONENT", state.historyParticipe)
    }
})

export default new Vuex.Store({
  strict:false,
    state,
    mutations,
    actions
})